import { render, staticRenderFns } from "./edit-pet-policy-form.vue?vue&type=template&id=70e350a6&scoped=true&"
import script from "./edit-pet-policy-form.vue?vue&type=script&lang=js&"
export * from "./edit-pet-policy-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e350a6",
  null
  
)

export default component.exports